import { render } from "./ContentElement.vue?vue&type=template&id=8273166c&scoped=true"
import script from "./ContentElement.vue?vue&type=script&lang=js"
export * from "./ContentElement.vue?vue&type=script&lang=js"

import "./ContentElement.vue?vue&type=style&index=0&id=8273166c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dymek\\Desktop\\Projects\\Lusterka Adam\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8273166c"]])

export default __exports__